import { Placeholder_Query } from "@/modules/crm/leads/graphql-queries/general-queries";
import { useLazyQuery } from "@apollo/client";
import storage from "@/services/storage";
import FeatureService from "@/services/feature-service";
import { FeatureKeys } from "@/services/dropdown-enums";

const UseGql = (
  defaultQuery,
  defaultParams = {},
  clientName = "",
  customHeaders = {},
  forceGql = false
) => {
  // added placeholder query when defaultQuery is undefined
  let parsedQuery = defaultQuery ?? Placeholder_Query;

  // init params
  const params = {
    fetchPolicy: "no-cache",
  };
  // add variables to params if needed
  if (Object.keys(defaultParams)?.length) {
    params.variables = defaultParams;
  }

  const [getData, { data, loading, refetch }] = useLazyQuery(
    parsedQuery,
    params
  );

  const isCRM = typeof window !== 'undefined' && (() => {
    try {
      const profile = JSON.parse(storage.getItem("Profile"));
      const features = FeatureService.resolveFeatures(profile);
      return FeatureService.hasFeature(features, FeatureKeys.CRM);
    } catch {
      return false;
    }
  })();

  const isPublicPage = typeof window !== 'undefined' && (
    window.location.pathname.includes("book-an-appointment") ||
    window.location.pathname.includes("reschedule-an-appointment") ||
    window.location.pathname.includes("cancel-an-appointment")
  );

  const shouldBlock = isPublicPage;

  // define executeQuery method
  // it will responsible to pass variables and check forceGql options
  const executeQuery = (variables = {}, options = {}) => {
    const shouldForce = forceGql || options?.forceGql;
    if (shouldBlock && !shouldForce) {
      return Promise.resolve({ data: {} });
    }
    if (!isCRM && !shouldForce) {
      return Promise.resolve({ data: {} });
    }

    const mergedHeaders = { ...customHeaders, ...options?.headers };

    if (Object.keys(variables)?.length) {
      return getData({
        variables,
        context: { clientName, headers: mergedHeaders },
      });
    } else {
      return getData({
        context: { clientName, headers: mergedHeaders },
      });
    }
  };

  const executeRefetch = (variables = {}) => {
    if (shouldBlock && !forceGql) {
      return Promise.resolve({ data: {} });
    }
    if (!isCRM && !forceGql) {
      return Promise.resolve({ data: {} });
    }
    return refetch(variables);
  };

  return { 
    loading: (shouldBlock && !forceGql) ? false : (!isCRM && !forceGql ? false : loading), 
    data: (shouldBlock && !forceGql) ? undefined : (!isCRM && !forceGql ? undefined : data), 
    executeQuery, 
    refetch: executeRefetch 
  };
};

export default UseGql;

